<template>
    <div class="theme-ghipss">
        <div class="overlay"></div>
            <top-nav />
        <section>
            <left-nav />
            <right-nav />
        </section>
        <section class="content">
            <div class="container-fluid">
                <div class="block-header">
                    <h2>INSTITUTIONS</h2>
                </div>

                <div class="row clearfix">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-15" id="txn_table_div">
                        <div class="card">
                            <div class="row header">
                                <div class="pull-left">
                                    <h2 v-show="firstSearch">
                                        <span> {{ bankId }}</span>
                                    </h2>
                                </div>
                                <div class="pull-right" style="margin:-10px 0px 0px 0px" v-show="firstSearch">
                                    <button type="button" class="btn btn-ghipss btn-circle waves-effect waves-circle waves-float" data-toggle="modal"
                                    data-target="#defaultModal" data-backdrop="static" @click="edit = false; clearValidation()">
                                        <i class="material-icons">add</i>
                                    </button>                  
                                </div>
                            </div>
                            <div class="row body">
                                <div class="container-fluid">
                                    <div class="pull-left">
                                        <p>
                                            <!-- Excel -->
                                        </p>
                                    </div>
                                    <div class="pull-right">
                                        <div class="form-group" style="margin:-10px 0px 0px 0px">
                                            <div class="form-line">
                                                <input type="text" placeholder="Search here..." v-model="searchInput" class="form-control" @input="searchEvent" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>FI Code</th>
                                                <th>FI Name</th>
                                                <th>Mail Recipients</th>
                                                <th>Status</th>
                                                <th>Created At</th>
                                                <th class="disabled-sorting text-right">Actions</th>

                                            </tr>
                                        </thead>
                                        <tbody v-if="filteredEntries.length > 0">
                                            <tr v-for="(bank, i) in filteredEntries" :key="i">
                                                <td>{{ bank.fiCode }}</td>
                                                <td>{{ bank.bankName }}</td>
                                                <td>{{ bank.mailRecipientList }}</td>
                                                <td>
                                                    <span v-if="bank.status" class="label bg-green">Active</span>
                                                    <span v-else class="label bg-red">Inactive</span>
                                                </td>
                                                <td>{{ getFormattedDate(bank.createdAt) }}</td>
                                                <td class="text-right">
                                                    <span v-if="bank.status">
                                                        <a href="#" @click="bankData = bank;edit = true;" class="btn btn-warning btn-circle waves-effect waves-circle waves-float"
                                                        data-toggle="modal" data-target="#defaultModal" data-backdrop="static">
                                                            <i class="material-icons">edit</i>
                                                        </a>
                                                        <!-- <a href="#" @click="bankUser = user; resetUser()" class="btn btn-round btn-info btn-icon btn-sm history">
                                                            <i class="fa fa-history"></i>
                                                        </a>                         -->
                                                        <a @click="bankData = bank; deleteBank()" class="btn btn-danger btn-circle waves-effect waves-circle waves-float m-l-5">
                                                            <i class="material-icons">delete</i>
                                                        </a>
                                                    </span>
                                                    <span v-else>
                                                        <a @click="bankData = bank; restoreBank()" class="btn btn-info btn-circle waves-effect waves-circle waves-float m-l-5">
                                                            <i class="material-icons">restore</i>
                                                        </a>
                                                    </span>
                                                </td>

                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="6" class="text-center">No records</td>
                                            </tr>
                                        </tbody>

                                    </table>

                                    <div class="row">
                                        <div class="col-md-6 col-sm-6 col-xs-6" style="padding: 10px 20px">
                                            <span class="pagination">
                                                showing {{ showInfo.from }} to {{ showInfo.to }} of {{ showInfo.of }} entries
                                            </span>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-xs-6">
                                            <ul class="pagination pull-right">
                                                <li :class="['page-item', {'disabled': currentPage === 1}]">
                                                    <a href="#" class="page-link" @click.prevent="currentPage = 1, paginateEntries()">
                                                        <span aria-hidden="true"><i class="fa fa-angle-double-left" aria-hidden="true"></i></span>
                                                    </a>
                                                </li>                      
                                                <li :class="['page-item', {'disabled': currentPage === 1}]">
                                                    <a class="page-link" href="#" aria-label="Previous" @click.prevent="currentPage < 1 ? currentPage = 1 : currentPage -= 1, paginateEntries()">
                                                        <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                                                    </a>
                                                </li>
                                                <li v-for="pagi in showPagination" :key="pagi" :class="['page-item', {'disabled': pagi === '...', 'active': pagi === currentPage}]">
                                                    <a href="#" class="page-link" @click.prevent="paginateEvent(pagi)">{{ pagi }}</a>
                                                </li>                    
                                                <li :class="['page-item', {'disabled': currentPage === allPages}]">
                                                    <a class="page-link" href="#" aria-label="Next" @click.prevent="currentPage > allPages ? currentPage = allPages : currentPage += 1, paginateEntries()">
                                                        <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                                                    </a>
                                                </li>
                                                <li :class="['page-item', {'disabled': currentPage === allPages}]">
                                                    <a href="#" class="page-link" @click.prevent="currentPage = allPages, paginateEntries()">
                                                        <span aria-hidden="true"><i class="fa fa-angle-double-right" aria-hidden="true"></i></span>            
                                                    </a>
                                                </li>                    
                                            </ul>            
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>    
        </section>

        <div class="modal fade" id="defaultModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="modal-title" v-if="edit">
                            Edit Institution ( {{ bankData.fiCode }} )
                        </h2>
                        <h2 v-else class="modal-title" id="defaultModalLabel">Add Institution</h2>
                    </div>
                    <div class="modal-body">
                            <form>
                                <label for="email_address">FI Code</label>
                                <div class="form-group">
                                    <div class="form-line">
                                        <input type="text" v-model="bankData.fiCode" class="form-control" placeholder="Enter FI code">
                                    </div>
                                    <span v-if="v$.bankData.fiCode.$error" class="text-danger">
                                        {{ v$.bankData.fiCode.$errors[0].$message }}
                                    </span>                                     
                                </div>
                                <label for="password">FI Name</label>
                                <div class="form-group">
                                    <div class="form-line">
                                        <input type="text" v-model="bankData.bankName" class="form-control" placeholder="Enter FI name">
                                    </div>
                                    <span v-if="v$.bankData.bankName.$error" class="text-danger">
                                        {{ v$.bankData.bankName.$errors[0].$message }}
                                    </span>                                     
                                </div>
                                <label for="password">Mail Recipients</label>
                                <div class="form-group">
                                    <div class="form-line">
                                        <!-- <input type="text" v-model="bankData.mailRecipientList" class="form-control" placeholder="Enter Mail Recipients (for multiple recipients, separate email addresses with a comma)"> -->
                                        <textarea rows="3" class="form-control no-resize" placeholder="Enter Mail Recipients (for multiple recipients, separate email addresses with commas eg. abc@gmail.com,xyz@yahoo.com,ax1@hotmil.com)" v-model="bankData.mailRecipientList"></textarea>

                                    </div>
                                                                
                                </div>                                
                            </form>
                    </div>
                    <div class="modal-footer">
                        <button v-if="edit" type="button" class="btn btn-warning waves-effect" @click.prevent="submitUpdateBankForm">Update</button>
                        <button type="button" v-else class="btn btn-success waves-effect" @click.prevent="submitAddBankForm">Save</button>
                        
                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal" @click="clearValidation">Close</button>
                    </div>
                    <!-- <div class="modal-footer" v-else>
                        <button type="button" class="btn btn-success waves-effect" @click.prevent="submitAddBankForm">Save</button>
                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal" @click="clearValidation">Close</button>
                    </div> -->

                </div>
            </div>
        </div>

    </div>    
</template>
<style scoped>

</style>
<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import axios from '@/axios.js';
import TopNav from "@/components/TopNav.vue";
import LeftNav from "@/components/LeftNav.vue";
import RightNav from "@/components/RightNav.vue";

import VueSelect from 'vue-next-select'
import '../../../public/css/vue-next-select-refactored.css'



import { $array } from 'alga-js';
import moment from "moment";

export default {
    name: 'Institutions',
    components: {
        TopNav,
        LeftNav,
        RightNav,
        VueSelect

    },
    data() {
        return {
            v$: useVuelidate(),

            edit: false,
            allBanks: [],
            bankId: '',
            // transactions: [],
            isDownloading: false,
            firstSearch: false,
            lastUpdateTime: '',
            bankData: {
                id: 0,
                fiCode: '',
                bankName: '',
                mailRecipientList: ''
            },

            entries:[],
            showEntries:[5, 10, 15, 25, 50, 75, 100],
            currentEntries: 10,
            filteredEntries: [],
            currentPage: 1,
            allPages: 1,
            searchInput: '',
            searchEntries: [], 

        }
    },
    validations() {
      return{
        bankData:{
            fiCode: {
            required,
            },
            bankName: {
            required,
            },
        }
      }
    },    
    methods: {
        handleSearchInput(event){
            console.log(event.target)
        },

        async submitAddBankForm(){
            this.v$.$validate() 
            this.v$.bankData.fiCode.$touch;
            this.v$.bankData.bankName.$touch;

            if (!this.v$.bankData.fiCode.$invalid && !this.v$.bankData.bankName.$invalid) { 
                $.LoadingOverlay("show");
                try {
                    const data = {
                        fiCode: this.bankData.fiCode,
                        bankName: this.bankData.bankName,
                        mailRecipientList: this.bankData.mailRecipientList,
                    }
                    const response = await axios.post('bank/create_bank', data);
                    if(response.status == 200){
                        this.generalResponse = response.data;
                        if(this.generalResponse.errorCode == '0'){
                        this.$swal('Success', 'Bank added successfully!', 'success')                

                        this.getAllBanks();

                        $('#defaultModal').modal('hide');

                        }else{
                        this.$swal('Failed', this.generalResponse.errorMessage, 'error')                

                        }
                    }else{
                        this.$swal('Failed', 'An unexpected error occurred...Try again!', 'error')                

                    }
                }
                catch(err) {
                    this.$swal('Failed', 'An unexpected error occurred...Try again!', 'error')                

                }finally{
                    $.LoadingOverlay("hide");
                    this.clearValidation();
                }

            }

        },

        async submitUpdateBankForm(){
            this.v$.$validate() 
            this.v$.bankData.fiCode.$touch;
            this.v$.bankData.bankName.$touch;

            if (!this.v$.bankData.fiCode.$invalid && !this.v$.bankData.bankName.$invalid) { 
                $.LoadingOverlay("show");

                try {
                    const data = {
                        id: this.bankData.id,
                        fiCode: this.bankData.fiCode,
                        bankName: this.bankData.bankName,
                        mailRecipientList: this.bankData.mailRecipientList,
                    }
                    const response = await axios.post('bank/update_bank', data);
                    if(response.status == 200){
                        this.generalResponse = response.data;
                        if(this.generalResponse.errorCode == '0'){
                        this.$swal('Success', 'Institution updated successfully!', 'success')                

                        this.getAllBanks();

                        }else{
                        this.$swal('Failed', this.generalResponse.errorMessage, 'error')                

                        }
                    }else{
                        this.$swal('Failed', 'An unexpected error occurred...Try again!', 'error')                

                    }

                }
                catch(err) {
                    this.$swal('Failed', 'An unexpected error occurred...Try again!', 'error')                

                }finally{
                    $.LoadingOverlay("hide");
                    this.clearValidation();
                    $('#defaultModal').modal('hide');
                    
                }

            }

        },

        async deleteBank() {
            this.$swal({
            title: 'Deactivate ( '+ this.bankData.fiCode +' )',
            text: 'Are you sure you want to deactivate this institution?',
            // type: 'warning',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCloseButton: true,
            showLoaderOnConfirm: true
            }).then((result) => {
            if(result.value) {
                axios.delete('bank/deactivate_bank/'+this.bankData.id)
                    .then(res => {
                        if(res.data.errorCode == '0'){
                            this.$swal('Success', 'Institution successfully deactivated!', 'success')
                            this.getAllBanks();

                        }else{
                            this.$swal('Failed', res.data.errorMessage, 'error')
                        }
                    }).catch(err => {
                        this.$swal('Failed', 'Institution could not be deactivated. Try again!', 'error')
                    });
            } 

            })
        },

        async restoreBank() {
            this.$swal({
            title: 'Reactivate ( '+ this.bankData.fiCode +' )',
            text: 'Are you sure you want to reactivate this institution?',
            // type: 'warning',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCloseButton: true,
            showLoaderOnConfirm: true
            }).then((result) => {
            if(result.value) {
                axios.post('bank/reactivate_bank/'+this.bankData.id)
                    .then(res => {
                        if(res.data.errorCode == '0'){
                            this.$swal('Success', 'Institution successfully reactivated!', 'success')
                            this.getAllBanks();

                        }else{
                            this.$swal('Failed', res.data.errorMessage, 'error')
                        }
                    }).catch(err => {
                        this.$swal('Failed', 'Institution could not be reactivated. Try again!', 'error')
                    });
            } 

            })
        },

        clearValidation(){
            this.v$.$reset();            
            this.bankData= {
                id: 0,
                fiCode: '',
                bankName: '',
                mailRecipientList: ''
            }
            this.edit = false;
        },

        async getAllBanks(){
            try{
                $("#txn_table_div").LoadingOverlay("show");
                this.isDownloading = true;

            const response = await axios.get("bank/get_banks");
            if (response.status == 200) {
                this.allBanks = response.data;
                this.filteredEntries = $array.paginate(this.allBanks)(this.currentPage, this.currentEntries) 
                this.allPages = $array.pages(this.allBanks, this.currentEntries)   

                // this.totalAmount = response.data.map(e => parseFloat(e.transaction_amount)).reduce((a,b) => a + b, 0);
                this.lastUpdateTime = moment(new Date()).format('hh:mm a');

                this.firstSearch = true;
                this.lastUpdateTime = moment(new Date()).format('hh:mm a');

            }else{
                this.$swal('Failed', 'Error loading records!', 'error')                

            }
            }catch(err){
                this.$swal('Failed', 'Error loading records!', 'error')                

            }finally{
                $("#txn_table_div").LoadingOverlay("hide");
                this.isDownloading = false;
            }
        },

        paginateEntries(){
            if(this.searchInput.length >= 1){
                this.searchEntries = $array.search(this.searchInput)(this.allBanks)
                this.filteredEntries = $array.paginate(this.searchEntries)(this.currentPage, this.currentEntries)
                this.allPages = $array.pages(this.searchEntries, this.currentEntries)

            }else{
                this.searchEntries = []
                this.filteredEntries = $array.paginate(this.allBanks)(this.currentPage, this.currentEntries)
                this.allPages = $array.pages(this.allBanks, this.currentEntries)
            
            }
        },

        paginateEvent(page){
            this.currentPage = page;
            this.paginateEntries();
        },
    
        searchEvent(){
            this.currentPage = 1
            this.paginateEntries()
        }, 

        getFormattedDate(date) {
        return moment(date).format("YYYY-MM-DD  hh:mm a");
        }, 

    },
    mounted() {
        if(localStorage.getItem('bankcode') == '000001'){
            if(localStorage.getItem('rolecode') != '4' && localStorage.getItem('rolecode') != '100'){
                this.$router.push('/')
            }else{        
                let externalScript = document.createElement('script')
                externalScript.setAttribute('src', '/js/admin.js')
                document.body.appendChild(externalScript)
                this.moment = moment;

                this.getAllBanks();
            }
        }else{
            this.$router.push('/')

        }
    },
    computed: {
        showInfo() {
            const getCurrentEntries = this.searchEntries.length <= 0 ? this.allBanks : this.searchEntries
            return $array.show(getCurrentEntries)(this.currentPage, this.currentEntries)
        },
        
        showPagination(){
            return $array.pagination(this.allPages, this.currentPage, 1)
        }
    },        
}
</script>